import {
  getTherapyPrepCategory,
  toEntryDate,
} from "./dailyCareReportEntryUtils";

const RAW_ID_PATTERN = /\b[A-Za-z0-9_-]{16,}\b/g;

const SOURCE_CATEGORY_LABELS = {
  behavior: "Behavior note",
  sleep: "Sleep note",
  food: "Food note",
  medication: "Medication note",
  mood: "Mood note",
  bathroom: "Bathroom note",
  dailyLog: "Timeline note",
};

const normalizeSourceId = (sourceId) => (
  typeof sourceId === "string" ? sourceId.trim() : ""
);

const getEntryTimestamp = (entry = {}) => (
  entry.timestamp || entry.date || entry.createdAt || null
);

const formatSourceDateLabel = (entry = {}) => {
  const date = toEntryDate(getEntryTimestamp(entry));
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

const getSourceCategoryLabel = (entry = {}) => {
  const category = getTherapyPrepCategory(entry) || "dailyLog";
  return SOURCE_CATEGORY_LABELS[category] || "Timeline note";
};

export const sanitizeTherapyPrepSourceText = (text = "") => (
  String(text || "")
    .replace(RAW_ID_PATTERN, "timeline note")
    .replace(/\s{2,}/g, " ")
    .trim()
);

export const buildTherapyPrepSourceReferences = (sourceIds = [], entries = []) => {
  const entriesById = new Map(
    entries
      .filter((entry) => entry?.id)
      .map((entry) => [entry.id, entry])
  );

  return [...new Set(sourceIds.map(normalizeSourceId).filter(Boolean))]
    .map((sourceId) => {
      const entry = entriesById.get(sourceId);
      if (!entry) {
        return {
          id: sourceId,
          label: "Timeline note",
          entry: null,
          linked: false,
        };
      }

      const dateLabel = formatSourceDateLabel(entry);
      return {
        id: sourceId,
        label: [getSourceCategoryLabel(entry), dateLabel].filter(Boolean).join(" · "),
        entry,
        linked: true,
      };
    });
};
